import { render, staticRenderFns } from "./ProductCardRatings.vue?vue&type=template&id=8da460e4&scoped=true&"
import script from "./ProductCardRatings.vue?vue&type=script&lang=js&"
export * from "./ProductCardRatings.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardRatings.vue?vue&type=style&index=0&id=8da460e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da460e4",
  null
  
)

export default component.exports